<template>
<div v-bind:class="{'ui loading form': (loaded==1)}">
  <form class="ui form segment">
    <app-header v-if="showMenu" ></app-header>

    <!--
    <div class="ui block header">

      
     

       <div class="three fields">
        <div class="field">
            <label>Buyer Corp ID:</label>
            <label >{{ this.corpId }}</label>
          </div>
          <div class="field">
            <label>RFQ Vendor Corp ID:</label>
              <label >{{ this.RFQvendorCorpID }}</label>
          </div>
          <div class="field">
           
             <label>RFQ Loc ID:</label>
              <label >{{ this.RFQlocID }} </label>
          </div>
    
      </div>

      <div class="one field">
        
          <div class="field">
            <label>Community:</label>
              <label >{{ this.CommunityName }} </label>
          </div>
      </div>



    </div>

-->
  
   

  <div class="ui attached segment">

  <div class="three fields">
        <div class="field">
            <label>Code</label>
            <input placeholder="Notes"  style="width:450px" name="_code" type="text"  ref="ipCode">
        </div>
         <div class="field">
            <label>Email</label>
            <input placeholder="Email"  style="width:450px" name="_email" type="text"  ref="ipEmail">
        </div>
         <div class="field">
            <label>Contact Name</label>
            <input placeholder="Contact Name"  style="width:450px" name="_contactName" type="text"  ref="ipContactName">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Contact Phone</label>
            <input placeholder="Contact Phone"  style="width:450px" name="_contactPhone" type="text"  ref="ipcontactPhone">
        </div>
         <div class="field">
            <label>Communication Mode</label>
            <input placeholder="Communication Mode"  style="width:450px" name="_communicationMode" type="text"  ref="ipCommunicationMode">
        </div>
         <div class="field">
            <label>Security Code</label>
            <input placeholder="Security Code"  style="width:450px" name="_secirityCode" type="text"  ref="ipSecurityCode">
        </div>
  
  </div>

    <div class="three fields">
        <div class="field">
            <label>Name</label>
            <input placeholder="Name"  style="width:450px" name="_name" type="text"  ref="ipName">
        </div>
         <div class="field">
            <label>Endpoint Url</label>
            <input placeholder="EndPointUrl"  style="width:450px" name="_endPointUrl" type="text"  ref="ipEndPointUrl">
        </div>
         <div class="field">
            <label>Active</label>
             <select class="ui input" style="width:340px"  v-model="activeStatusSelected"  >
                      <option v-for="statusType in activeStatus" v-bind:value="statusType.statusId" v-bind:key="statusType.statusId" >
                          {{ statusType.name }}
                      </option>
              </select>
        </div>
  
  </div>

   <div class="three fields">
        <div class="field">
            <label>Mode</label>
             <select class="ui input" style="width:340px"  v-model="modeTypeSelected"  >
                      <option v-for="modeType in modes" v-bind:value="modeType.modeTypeId" v-bind:key="modeType.modeTypeId" >
                          {{ modeType.name }}
                      </option>
            </select>
        </div>
         <div class="field">
            <label>Xref Code</label>
            <input placeholder="Xref Code"  style="width:450px" name="_xrefCode" type="text"  ref="ipXrefCode">
        </div>
         <div class="field">
           
        </div>
  
  </div>

  <div class="three fields">
        <div class="field">
            <label>Supplier Identity</label>
            <input placeholder="Supplier Identity"  style="width:450px" name="_supplierIdentity" type="text"  ref="ipSupplierIdentity">
        </div>
         <div class="field">
            <label>Buyer Identity</label>
            <input placeholder="Buyer Identity"  style="width:450px" name="_buyerIdentity" type="text"  ref="ipBuyerIdentity">
        </div>
         <div class="field">
            <label>Received Location</label>
            <input placeholder="Received Location"  style="width:450px" name="_receivedLocation" type="text"  ref="ipReceivedLocation">
        </div>
  
  </div>



 <div class="ui primary submit button"   @click="updatePartnerDetails()" >Update</div>
          <div class="ui button"  @click="closeWindow()">Close Current Window</div>


</div>

    </form>
  </div>



 
</template>

<script>
import axios from "axios";
import Header from '@/components/Header.vue';
import Vue from 'vue'


export default {
  components: {
    appHeader: Header
 
  },
  data () {
    return {
      loaded : "1",
      httpOptions: {
      headers: {
      authorization: ""
      }
    },
      loading: '',
      showMenu :false,
      headerData : [],
      refId:'' ,
      partnerTypeSelected : '',
      type : '',
       modes : [
    	{ modeTypeId: 'QA', name: 'QA' },
      { modeTypeId: 'PR', name: 'PROD' }
      ],
      modeTypeSelected : "",
      activeStatus : [
        { statusId: 1, name: 'Active' },
        { statusId: 0, name: 'In-Active' }
      ],
    activeStatusSelected : "",
    /*
      refId:'' ,
      code:'' ,
      email:'' , 
      contactName:'' , 
      contactPhone:'' ,
      communicationMode:'' ,
      securityCode:'' ,
      name:'' ,
      endPointUrl:'' ,
      active:'' ,
      mode:'' ,
      xrefCode:'' ,
      receivedLocation:'' ,
      supplierIdentity:'' ,
      buyerIdentity:'' ,
 */
      
      input: {
        refreshtoken : ""
      }   ,
      diffMins : 0,
      refreshToken_Event_Fired : 0 ,
    moreParams: { _filter : '' , _buyer_code : '',_vendor_code : '',_loc_code : '', _corc_code : ''},
    
   }
 },
 methods: {
   bindPartnerDetails(){
         if(localStorage.getItem('id_token')){
         this.loaded = 1;
         axios({ method: "GET", "url": Vue.prototype.$hostname + "getpartnerlist/" + CryptoJS.AES.decrypt( this.$route.query.type, 'corcentric').toString(CryptoJS.enc.Latin1) + "/" + 
         CryptoJS.AES.decrypt( this.$route.query.refId, 'corcentric').toString(CryptoJS.enc.Latin1) +  "/N" 
         , 
              "headers": 
               { 
                  "content-type": "application/json",
                  "authorization": "bearer " + localStorage.getItem('id_token') 
                } }).then
                (
                    result => {
                    this.headerData = result.data;
                    console.log(this.headerData);
                       this.refId = this.headerData[0]. refId;
                       this.$refs.ipCode.value =  this.headerData[0]. code;
                       this.$refs.ipEmail.value = this.headerData[0].email;
                       this.$refs.ipContactName.value =  this.headerData[0].contactName;
                       this.$refs.ipcontactPhone.value = this.headerData[0].contactPhone;

                       this.$refs.ipCommunicationMode.value = this.headerData[0].communicationMode;
                       this.$refs.ipSecurityCode.value =  this.headerData[0].securityCode;
                       this.$refs.ipName.value = this.headerData[0].name;
                       this.$refs.ipEndPointUrl.value =  this.headerData[0].endPointUrl;
                        this.activeStatusSelected = this.headerData[0].active;

                       this.modeTypeSelected = this.headerData[0].mode;
                       this.$refs.ipXrefCode.value =  this.headerData[0]. xrefCode;
                       this.$refs.ipSupplierIdentity.value = this.headerData[0].supplierIdentity;
                       this.$refs.ipBuyerIdentity.value =  this.headerData[0].buyerIdentity;
                       this.$refs.ipReceivedLocation.value = this.headerData[0].receivedLocation;
               }, 
                error => {
                    console.error(error);
                    this.sessionExpired(error.response.status);
                });
              this.loaded = 2;
        }       
    },
    
   
sessionExpired(errorStatus){
      if (errorStatus === 403 && this.tokenExpired === 0 ) {
        this.tokenExpired = 1;
        alert('Sesssion expired.Please login again!!');
        this.$router.push({name: 'Login'});
    }
   },


   closeWindow(){
    window.close();
  },

  updatePartnerDetails(){
     
        swal({
        title: "",
        text: "Are you sure, to update partner Details?",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: "Yes, Update it!",
        closeOnConfirm: true
        },() => {
         
          axios({ method: "POST", "url": Vue.prototype.$hostname +  "updatepartner", 
            "data": {
            type : this.partnerTypeSelected,
            ref_id :  this.refId ,
            code : this.$refs.ipCode.value.trim() ,
            email : this.$refs.ipCode.value.trim(),
            contact_name : this.$refs.ipContactName.value.trim(),
            contact_phone  : this.$refs.ipcontactPhone.value.trim(),
            communication_mode : this.$refs.ipCommunicationMode.value.trim(),
            security_code :  this.$refs.ipSecurityCode.value.trim(),
            name :  this.$refs.ipName.value.trim(),
            endpoint_url :  this.$refs.ipEndPointUrl.value.trim(),
            active : this.activeStatusSelected ,
            mode :   this.modeTypeSelected,
            xref_code :  this.$refs.ipXrefCode.value.trim(),
            received_location : this.$refs.ipReceivedLocation.value.trim(),
            supplier_identity : this.$refs.ipSupplierIdentity.value.trim(),
            buyer_identity : this.$refs.ipBuyerIdentity.value.trim()
              
            }, 
            "headers": 
            { 
              "content-type": "application/json" ,
              "authorization": "bearer " + localStorage.getItem('id_token') 
            }  }).then
            (
              result => {
                sweetAlert('Data has been updated successfully!', '', 'success')
              }, 
            error => {
            console.error(error);
            this.sessionExpired(error.response.status);
            sweetAlert('Something\'s Wrong!', error, 'error')
            });
      
        
      })
      
    },

   checkTokenExpired(){
    if(this.refreshToken_Event_Fired == 0){
    this.getTokenExpiryTime();/* Get Token Expiry time  in Minutes */
    if(this.diffMins <= Vue.prototype.$session_Expire_in && this.diffMins > 0  ){ /* If Token Expiring in (expires_in from service) Mins,then get refereh token */
      this.refreshToken_Event_Fired = 1 ;
      this.getRefreshToken();
      this.refreshToken_Event_Fired = 0;
    }
     }
    },
    async getRefreshToken() {
    this.input['refreshtoken'] = localStorage.getItem('refresh_token')
    await axios({ method: "POST", "url": Vue.prototype.$appName + "token/refreshtoken", 
      "data": this.input, 
      "headers": { "Access-Control-Allow-Origin" : "*",
      "content-type": "application/json" } }).then
      (
          result => {
          this.response = result.data;
          localStorage.setItem('id_token', result.data.access_token);
          localStorage.setItem('refresh_token', result.data.refresh_token);

          var now = new Date();
          now.setMinutes(now.getMinutes() + Math.floor(result.data.expires_in / 60)  ); // timestamp
          now = new Date(now); // Date object
          localStorage.setItem('expiry_date', now);
         }, 
      error => {
        this.refreshToken_Event_Fired = 0;
        console.error(error);
      });

    },
    getTokenExpiryTime() {
      var expiry_date =  new Date(localStorage.getItem('expiry_date'));
      var today = new Date();
      var diffMs = (expiry_date - today); // milliseconds between now & logintime
      this.diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes
       
    },
    preg_quote ( str ) {
       return (str+'').replace(/([\\\.\+\*\?\[\^\]\$\(\)\{\}\=\!\<\>\|\:])/g, "\\$1");
    },
    highlight (needle, haystack) {
      return haystack.replace(
        new RegExp('(' + this.preg_quote(needle) + ')', 'ig'),
        '<span class="highlight">$1</span>'
        )
    },
    
    
    
    showLoader () {
      this.loading = 'loading'
    },
    hideLoader () {
      this.loading = ''
    },
    
    


  },
 created() {
     if(!localStorage.getItem('id_token') ){
       this.$router.push({name: 'Login'});
     }else{
     this.checkTokenExpired();
     this.partnerTypeSelected = CryptoJS.AES.decrypt( this.$route.query.type, 'corcentric').toString(CryptoJS.enc.Latin1);

       this.bindPartnerDetails();

 
     }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/manage-cxml/UpdatePartner.vue